import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
export function BenefitsSection() {
  const benefits = [<Fragment data-id="element-19">
      Aprenderás exactamente por dónde empezar para bajar de peso{' '}
      <strong data-id="element-20">sin sentirte perdido ni abrumado</strong> con tanta información.
    </Fragment>, <Fragment data-id="element-21">
      Conocerás una forma simple de bajar grasa{' '}
      <strong data-id="element-22">sin volver a caer en el ciclo</strong> de arrancar, abandonar y
      empezar de cero cada lunes.
    </Fragment>, <Fragment data-id="element-23">
      Aprenderás a volver a construir esa versión de vos que se veía mejor,{' '}
      <strong data-id="element-24">se sentía más liviana y tenía más control</strong> sobre su
      cuerpo.
    </Fragment>, <Fragment data-id="element-25">
      Sabrás cómo <strong data-id="element-26">evitar el efecto rebote</strong> para no bajar unos
      kilos y recuperarlos al poco tiempo.
    </Fragment>, <Fragment data-id="element-27">
      Podrás <strong data-id="element-28">recuperar la confianza</strong> para sacarte la remera en
      la playa, la piscina o la intimidad sin sentir incomodidad.
    </Fragment>];
  return <section className="py-14 md:py-20 bg-black pt-[10px] pb-[10px] space-y-[32px]" data-id="element-29">
      <div className="container mx-auto px-5 sm:px-6 md:px-8" data-id="element-30">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-4xl mx-auto bg-zinc-900 rounded-3xl shadow-2xl p-8 md:p-16 border border-zinc-800 pt-[10px] pb-[10px]" data-id="element-31">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-display text-white md:mb-24 text-center uppercase tracking-tight leading-[0.95] mt-[20px] mb-[20px]" data-id="element-32">
            Con Plan Anti Panza vas a lograr{' '}
            <span className="text-orange-500" data-id="element-33">mucho más que bajar peso</span>
          </h2>

          <div className="space-y-8" data-id="element-34">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: 0.03 * index
          }} className="flex items-start gap-6 border-b border-zinc-800/50 last:border-b-0 last:pb-0 pt-[0px] pb-[0px]" data-id="element-35">
                <div className="w-10 h-10 bg-orange-500/10 border border-orange-500/30 text-orange-500 rounded-full flex items-center justify-center flex-shrink-0 font-display text-xl" data-id="element-36">
                  {index + 1}
                </div>
                <p className="text-zinc-300 leading-relaxed text-lg md:text-xl pt-1" data-id="element-37">
                  {benefit}
                </p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}